export const GREY_COLOR = '#D9D9D9'

//////////////////////
// Customers Colors //
//////////////////////

export const FREE_COLOR = '#4BA75D'
export const PLUS_COLOR = '#0096D4'
export const PRO_COLOR = '#FDB022'

//////////////////////
// Suppliers Colors //
//////////////////////

export const STANDARD_COLOR = '#4BA75D'
export const BUSINESS_COLOR = '#0096D4'
export const ENTERPRISE_COLOR = '#FDB022'

///////////////////////////////
// Buyers & Suppliers Colors //
///////////////////////////////

export const BUYERS_COLOR = '#4BA75D'
export const SUPPLIERS_COLOR = '#0096D4'
